const Header = (function () {
    let burger, menu, lastScrollTop = 0;

    const toggleBurger = () => {
        burger.classList.toggle('open');
        menu.classList.toggle('open');
    };

    const handleScroll = () => {
        const header = document.querySelector('.header');
        const isHeaderBg = header.classList.contains('header--bg-full');
        const headerHeight = header.offsetHeight;
        let currentScroll = document.documentElement.scrollTop;

        currentScroll > lastScrollTop
            ? header.classList.add('hidden')
            : header.classList.remove('hidden')

        !isHeaderBg && (currentScroll > headerHeight + 50)
            ? header.classList.add('header--bg')
            : header.classList.remove('header--bg')

        lastScrollTop = (currentScroll <= headerHeight) ? headerHeight : currentScroll;
    };

    const handleClick = ({ target }) => {
        const isLink = target.classList.contains('menu__link');
        isLink ? toggleBurger() : false
    }

    const init = () => {
        burger = document.querySelector('.burger');
        menu = document.querySelector('.menu');

        if (burger && menu) {
            burger.addEventListener('click', toggleBurger);
        }

        menu.addEventListener('click', handleClick);
        window.addEventListener('scroll', handleScroll);
    };

    return {
        init
    };
})();

export default Header;